/* Custom Reaven — prodotti suggeriti nel cart drawer.
   L'elemento vive dentro .drawer__inner: ogni add/update del carrello
   ri-renderizza il drawer (cart-drawer.js / cart.js), l'elemento viene
   ricreato e il connectedCallback rifetcha i suggerimenti.
   Multi-seed (restyling 2026): usa fino a 3 prodotti del carrello come
   seme, unisce i risultati deduplicati e rispetta il cap della sezione. */

if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      static MAX_SEEDS = 3;

      connectedCallback() {
        const baseUrl = this.dataset.url;
        const productIds = (this.dataset.productIds || this.dataset.productId || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean)
          .slice(0, CartDrawerRecommendations.MAX_SEEDS);

        if (!productIds.length || !baseUrl) {
          this.innerHTML = '';
          return;
        }

        const separator = baseUrl.includes('?') ? '&' : '?';
        const fetches = productIds.map((productId) => {
          const url = `${baseUrl}${separator}section_id=cart-drawer-recommendations&product_id=${productId}&limit=8&intent=related`;
          return fetch(url)
            .then((response) => response.text())
            .catch((error) => {
              console.error('cart-drawer-recommendations:', error);
              return null;
            });
        });

        Promise.all(fetches).then((responses) => {
          let container = null;
          let list = null;
          const seen = new Set();
          let cap = Infinity;

          responses.filter(Boolean).forEach((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const content = html.querySelector('.cart-drawer-recommendations__content');
            if (!content) return;

            const items = content.querySelectorAll('[data-product-url]');
            if (!container) {
              // Il primo contenuto valido fa da contenitore; il cap arriva dalla sezione
              container = content;
              list = content.querySelector('ul');
              cap = parseInt(content.dataset.productsToShow, 10) || items.length || 3;
              items.forEach((item, index) => {
                if (index < cap) seen.add(item.dataset.productUrl);
                else item.remove();
              });
              return;
            }

            if (!list) return;
            items.forEach((item) => {
              if (seen.size >= cap || seen.has(item.dataset.productUrl)) return;
              seen.add(item.dataset.productUrl);
              list.appendChild(item);
            });
          });

          this.innerHTML = '';
          if (container && seen.size > 0) this.appendChild(container);
        });
      }
    }
  );
}
